import { QIcon_chevron_right } from '@repo/icons/index'
import classNames from 'classnames'
import { IC_CHECK_CIRCLE, IC_UNCHECK_CIRCLE } from '../../modules/images'
import { COLORS } from '../../modules/vars'

interface TodoCheckBoxProps {
  title: string
  subText?: string
  subTextBelow?: string
  checked: boolean
  paddingX?: number
  noArrow?: boolean
  dataRef?: string
  clx?: string
  onClick?: (e) => void
}

const TodoCheckBox = ({
  title,
  subText,
  subTextBelow,
  checked,
  paddingX,
  noArrow,
  dataRef,
  clx,
  onClick,
}: TodoCheckBoxProps) => {
  return (
    <>
      <div
        data-ref={dataRef}
        onClick={onClick}
        style={{ maxWidth: 300, paddingLeft: `${paddingX || 16}px`, paddingRight: `${paddingX || 16}px` }}
        className={classNames(
          { 'py-[16px]': !subTextBelow },
          { 'cursor-pointer': !noArrow },
          clx,
          { 'py-[8px]': subTextBelow },
          'w-full items-center rounded-md bg-gray-50'
        )}
      >
        <div className="flex flex-col">
          <div className="flex items-center">
            <img src={checked ? IC_CHECK_CIRCLE : IC_UNCHECK_CIRCLE} className="max-w-none" alt="Check" />
            <div
              className={classNames(
                { 'text-gray-700': !noArrow },
                { 'text-gray-300': noArrow },
                'text-h5 mb-[0px] ml-[8px]'
              )}
            >
              {title}
            </div>
            <div className="ml-auto flex items-center">
              {!noArrow && <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />}

              <span className="text-[12px] font-normal text-gray-300">{noArrow && !!subText && subText}</span>
            </div>
          </div>
          <div className="text-h6 pl-[32px] text-gray-500">{subTextBelow}</div>
        </div>
      </div>
    </>
  )
}

export default TodoCheckBox
